import { Stack } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';


import { HeadingWrapper, ModalContent, ModalFooter, StyledBox, StyledModalBox, StyledStack } from './DispatchNSInputPopup.styles';
import { LocationNodeData } from '../../../@types';
import { Button, ButtonColorProps, ButtonVariantProps } from '../../../components/atoms/Button';
import { useSearchNodeByParentId } from '../../../queries/live-search-query';
import { getHasCodeForNodeSearch } from '../../../utils/services';
import { CloseIcon } from '../../atoms/CloseIcon';
import { LiveSearchBox, LiveSearchListItem } from '../../atoms/LiveSearchBox';
import { Modal } from '../../atoms/Modal';
import { Typography } from '../../atoms/Typography';
import { LocationSearchItem } from '../../molecules/LocationSearchItem';

import { DispatchNSInputPopupProps } from '.';

export const DispatchNSInputPopup: React.FC<DispatchNSInputPopupProps> = ({
  sourceLocation,
  partTypeName,
  locationData,
  isOpen,
  sourceLocationName,
  onChange,
  onClick,
  onCancel,
  onClose
}) => {
  const [locationName, setLocationName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setLocationName(sourceLocationName);
  }, [sourceLocationName, isOpen]);

  const searchNodeByParentId = useSearchNodeByParentId();

  isOpen && !!locationName && sourceLocationName === locationName && inputRef.current?.select();
  isOpen && !sourceLocationName && !locationName && inputRef.current?.focus();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
    >
      <StyledModalBox>
        <CloseIcon handleClose={onClose} />
        <ModalContent>
          <StyledBox>
            <LiveSearchBox
              inputRef={inputRef}
              title="Scan source location"
              timeOffset={400}
              value={locationName}
              onClearValue={() => { 
                onChange({ id: sourceLocation });
                setLocationName('');
              }}
              renderItem={(props: any, option: any) => { 
                return (
                  <LiveSearchListItem {...props}>
                    <LocationSearchItem data={option} />
                  </LiveSearchListItem>
                );
              }}
              onChange={(obj: LocationNodeData) => {
                setLocationName(obj?.name);
                onChange(obj);
              }}
              onApiInvoke={async (name: string) => {
                const originalValue = name;
                if (name.includes('\n')) {
                  name = name.replace(/\n/g, '');
                }
                const hasCode = getHasCodeForNodeSearch(name);
                const result = await searchNodeByParentId.mutateAsync({ selectedParentId: sourceLocation, name, hasCode: hasCode, includeParentNode: true, includeSiblings: true });
                if (result?.length > 0 && originalValue.includes('\n')) {
                  setLocationName(result[0]?.name);
                  onChange(result[0]);
                }
                return result;
              }}
            />
          </StyledBox>
          <HeadingWrapper>Move <b>{partTypeName}</b> from: </HeadingWrapper>
          {locationData.map((item, index) => 
            <StyledStack direction="row" width="auto" justifyContent="space-between" key={index} onClick={() => onClick(item)}>
              <Stack direction="column">
                <Typography>{item.locationName}</Typography>
                <Typography>{item.condition} | Qty: {item.quantity}</Typography>
              </Stack>
              <Stack alignSelf="flex-end">
                <Typography>{item.fleetTagName}</Typography>
              </Stack>
            </StyledStack>
          )}
        </ModalContent>
        <ModalFooter>
          <Button variant={ButtonVariantProps.Primary} color={ButtonColorProps.Error} onClick={onCancel}>
            Cancel
          </Button>
        </ModalFooter>
      </StyledModalBox>
    </Modal>
  );
};